import { orderModule } from '@/store/components/pdv-balcao/order/OrderStore';
import { orderItensModule } from '@/store/components/pdv-balcao/order-itens/OrderItensStore';

export const pdvBalcaoModule = {
    namespaced:true,
    strict: process.env.NODE_ENV !== 'production',
    state:{
        orderItens:[]
    },
    mutations:{

    },
    actions:{
        // Order Itens Functions

        // Order Functions

    },
    modules:{
        orderModule,
        orderItensModule
    },    
}